
import { CircularProgress, Box } from '@mui/material';

export const LoadingScreen = () => {

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <CircularProgress color='secondary' />
        </Box>
    )
}
